import { Campaign } from '@/modules/draw/campaigns/types/Campaign.ts'
import { CampaignListResponse } from '@/modules/draw/campaigns/services/apiValidation/campaignListApiValidation.ts'

export const campaignsPage1: { data: CampaignListResponse } = {
  data: {
    results: [
      {
        id: 1,
        name: 'Campaña de Verano',
        code: 'CMP-VER-2026',
        conceptName: 'Sol y Playa',
        tagline: 'Refresca tu verano',
        description: 'Campaña promocional de temporada.',
        status: 'ACTIVE',
        startDate: '2026-01-15',
        endDate: '2026-04-30',
        deliveryDate: '2026-07-05',
        isActive: true
      },
      {
        id: 2,
        name: 'Campaña Navideña',
        code: 'CMP-NAV-2026',
        conceptName: 'Magia de Diciembre',
        tagline: 'Regala felicidad',
        description: 'Sorteo especial de fin de año.',
        status: 'DRAFT',
        startDate: '2026-11-01',
        endDate: '2026-12-31',
        deliveryDate: '2027-01-10',
        isActive: false
      },
      {
        id: 3,
        name: 'Campaña Aniversario',
        code: 'CMP-ANV-2025',
        conceptName: 'Weppa Cumple Años',
        tagline: 'Celebrá con nosotros',
        description: 'Campaña de aniversario con premios sorpresa.',
        status: 'PAUSED',
        startDate: '2025-09-01',
        endDate: '2025-10-15',
        deliveryDate: '2025-10-30',
        isActive: true
      },
      {
        id: 4,
        name: 'Campaña Regreso a Clases',
        code: 'CMP-ESC-2025',
        conceptName: 'Vuelta al Cole',
        tagline: 'Prepará el año escolar',
        description: 'Campaña finalizada de útiles escolares.',
        status: 'CLOSED',
        startDate: '2025-01-05',
        endDate: '2025-02-28',
        deliveryDate: '2025-03-10',
        isActive: false
      }
    ],
    status: true,
    pagination: {
      next: false,
      prev: false,
      start: 1,
      end: 4,
      range: [1],
      count: 4,
      pages: 1,
      total: 4,
      limit: 20
    }
  }
}

export const campaignDetail: { data: Campaign } = {
  data: campaignsPage1.data.results[0]
}
